import {useEffect, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import ErrorPanel from '../components/ErrorPanel';
import Header from '../components/Header';
import Experiences from '../components/experiences/Experiences';
import Loading from '../components/Loading';
import {fetchHrProject} from '../utils/api';
import axios from 'axios';
import {copyLinkToClipboard, scrollToElement} from '../utils/helpers';
import NavBack from '../components/dashboard/NavBack';
import Support from '../components/dashboard/Support';
import EmailForm from '../components/dashboard/EmailForm';
import Popup from '../components/Popup';
import Logs from '../components/dashboard/Logs';
import HeroArea from '../components/dashboard/HeroArea';
import SectionInvitation from '../components/dashboard/SectionInvitation';
import SectionGeneralInfo from '../components/dashboard/SectionGeneralInfo';

const DashboardSingle = () => {
  //params
  const location = useLocation();
  const state = location.state as {
    customer: HRCustomer;
    jwtToken: string;
    hideBack: boolean;
  };

  const {token} = useParams();

  const {t} = useTranslation();

  const [status, setStatus] = useState<'loading' | 'error' | 'loaded'>(
    'loading'
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [project, setProject] = useState<HRProject>();

  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [logsPopupOpen, setLogsPopupOpen] = useState(false);

  useEffect(() => {
    const getData = async (jwtToken: string, token: string) => {
      try {
        const project = await fetchHrProject(jwtToken, token);
        setProject(project);
        setStatus('loaded');
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          setErrorMessage(t(err.response.data.message));
        } else {
          setErrorMessage(t('errors.generic-error'));
        }
        setStatus('error');
      }
    };

    if (state && state.jwtToken && token) {
      getData(state.jwtToken, token);
    } else {
      setStatus('error');
      setErrorMessage(t('errors.generic-error'));
    }
  }, [state, token, t]);

  const renderMain = () => {
    if (status === 'loading') {
      return <Loading />;
    }

    if (status === 'error') {
      return <ErrorPanel errorMessage={errorMessage} />;
    }

    if (status === 'loaded' && project) {
      return (
        <>
          {!state.hideBack && <NavBack />}
          <HeroArea
            title={t('dashboard.title')}
            subtitle={t('dashboard.subtitle')}
            refName={project.name || '-'}
            buttonText={t('dashboard.see-plays')}
            onButtonClick={() => scrollToElement('giocate')}
          />

          <SectionInvitation
            onLinkClick={() =>
              copyLinkToClipboard(
                `https://play.game2value.it/join/${project.token}`,
                t('dashboard.link-copied')
              )
            }
            onEmailClick={() => setEmailPopupOpen(true)}
            onLogsClick={() => setLogsPopupOpen(true)}
          />

          <SectionGeneralInfo
            totalExperience={project.totalExperience || 0}
            totalExperienceCompleted={project.totalExperienceCompleted || 0}
            remainingParticipants={project.remainingParticipants || 0}
          />

          <div id="giocate">
            <Experiences jwtToken={state.jwtToken} token={token} />
          </div>

          <Popup
            isBig
            isOpen={logsPopupOpen}
            onClose={() => setLogsPopupOpen(false)}
          >
            {logsPopupOpen && (
              <Logs projectToken={token || ''} jwtToken={state.jwtToken} />
            )}
          </Popup>

          <Popup
            isBig
            isOpen={emailPopupOpen}
            onClose={() => setEmailPopupOpen(false)}
          >
            <EmailForm
              project={project}
              jwtToken={state.jwtToken}
              onCancel={() => setEmailPopupOpen(false)}
            />
          </Popup>
        </>
      );
    }
  };

  return (
    <>
      <Header
        clientLogo={project?.customer?.logo}
        clientName={project?.customer?.name}
      />
      <div style={{flex: '1'}}>{renderMain()}</div>
      <Support />
    </>
  );
};

export default DashboardSingle;
